import Angular from "angular";
import Controller from "./chart-booking-services.controller";
import Template from "./chart-booking-services.html";

export default Angular.module('chart-booking-services', [])
    .component('chartBookingServices', {
        template: Template,
        controller: Controller,
        bindings: {
            bookings: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-services/chart-booking-services.js